export default __webpack_public_path__ + "static/media/protected.91f24bcd.svg";